module.exports = __webpack_public_path__ + "static/media/sc15.22.3a98d2f1.mp4";